// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"30249b0464342ca71269","339":"938208e886cb0e3d2cec"}[chunkId] + ".js";
};